/**
 * Client service for Construction Starter Templates Status.
 * R39 B8.a (plan docs/plans/sector-operations.md row B8 :68).
 * Wraps callables via callable(); components never import firebase/*.
 */

import { callable } from './callable'
import type {
  GetConStarterStatusInput,
  GetConStarterStatusResult,
} from '../types/ops'

export async function getConStarterStatus(
  input: GetConStarterStatusInput,
): Promise<GetConStarterStatusResult> {
  return callable<GetConStarterStatusInput, GetConStarterStatusResult>('getConStarterStatus', input)
}
